import {Component, ElementRef, EventEmitter, Inject, Input, OnChanges, OnDestroy, OnInit, Output, Signal, SimpleChanges, ViewChild, WritableSignal} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {isArray} from 'lodash-es';
import {lang} from 'moment';

export interface MatDialogData {
    controlsList?: string;
    oncontextmenu?: string;
    controls?: boolean;
    muted?: string;
    video?: {
        uri: string;
        filemime: string;
        subtitles: {
            [key: string]: string;
        }
    };
    title?: string;
}

@Component({
    selector: 'app-shared-video',
    templateUrl: './shared-video.component.html',
    styleUrls: ['./shared-video.component.scss'],
    standalone: false
})
export class SharedVideoComponent implements OnInit, OnDestroy, OnChanges {
    @Input() controlsList?: string = undefined;
    @Input() oncontextmenu?: string = undefined;
    @Input() controls = false;
    @Input() muted: string = undefined;
    @Input() public video?: {
        uri: string;
        filemime?: string;
        subtitles?: {
            [key: string]: string;
        }
    };
    @Input() watchTime!: WritableSignal<number>;
    @Input() stopTimerTrigger = false;
    public source!: string;
    public filemime: string;
    public subtitles: { label: string; lang: string; url: string | SafeResourceUrl }[] = [];
    private initialMutedState: boolean;
    private timer: any = null;
    @ViewChild('myVideo') private videoElement: ElementRef;

    constructor(public sanitizer: DomSanitizer, @Inject(MAT_DIALOG_DATA) public data?: MatDialogData) {
    }

    ngOnInit(): void {
        if (this.data?.controlsList) {
            this.controlsList = this.data.controlsList;
        }
        if (this.data?.controls) {
            this.controls = this.data.controls;
        }
        if (this.data?.muted) {
            this.muted = this.data.muted;
        }
        if (this.data?.video) {
            this.video = this.data.video;
            this.source = this.video.uri;
            this.filemime = this.video.filemime;
        }
        if (this.data?.oncontextmenu) {
            this.oncontextmenu = this.data.oncontextmenu;
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['stopTimerTrigger']?.currentValue === true) {
            this.stopTimer();
        }

        this.source = this.video.uri;
        this.filemime = this.video.filemime;
        if (this.video?.subtitles) {
            this.subtitles = Object.keys(this.video.subtitles).map(lang => {
                return {
                    lang,
                    url: this.sanitizer.bypassSecurityTrustResourceUrl(this.video.subtitles[lang]),
                    label: 'video.subtitles_label_' + lang,
                };
            });
        }
    }

    ngAfterViewInit(): void {
        const video = this.videoElement.nativeElement as HTMLVideoElement;
        this.initialMutedState = video.muted;
        video.addEventListener('volumechange', () => {
            // block mute button effect if activities is set muted
            if (video.muted === false && this.initialMutedState === true) {
                video.muted = this.initialMutedState;
            }
        });

        video.addEventListener('play', () => {
            this.stopTimer();
            this.timer = setInterval(() => {
                if (!video.paused && !video.ended) {
                    this.watchTime.update(t => Number(t || 0) + 1);
                }
            }, 1000);
        });

        video.addEventListener('pause', () => {
            clearInterval(this.timer);
        });

        video.addEventListener('ended', () => {
            clearInterval(this.timer);

        });

        video.addEventListener('volumechange', () => {
            if (video.muted === false && this.initialMutedState === true) {
                video.muted = this.initialMutedState;
            }
        });
    }

    public onContextMenu(event: MouseEvent): boolean {
        event.preventDefault();
        return false;
    }

    private stopTimer(): void {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    ngOnDestroy(): void {
        this.stopTimer();
    }
}
